<template>
  <div class="music-container">
    <player-controls class="player-controls" />
    <music-tree class="music-tree" />
    <div class="album-listing">
      <music-album-listing />
    </div>
    <music-footer class="music-footer" />
  </div>
</template>

<script lang="ts">
import PlayerControls from '@/components/PlayerControls.vue';
import MusicTree from './MusicTree.vue';
import MusicAlbumListing from './MusicAlbumListing.vue';
import MusicFooter from './MusicFooter.vue';

export default {
  setup() {
    return {};
  },
  components: {
    PlayerControls,
    MusicTree,
    MusicAlbumListing,
    MusicFooter
  }
};
</script>

<style lang="scss" scoped>
.music-container {
  display: grid;
  height: 100%;
  width: 100%;
  grid-template:
    "header header" 4rem
    "tree albums" auto
    "footer footer" 2rem
    / 10rem auto;

  .player-controls {
    grid-area: header;
    background-color: magenta;
  }

  .music-tree {
    grid-area: tree;
    background-color: lime;
  }

  .album-listing {
    grid-area: albums;
    background-color: firebrick;
    overflow-y: scroll;
  }

  .music-footer {
    grid-area: footer;
    background-color: cyan;
  }
}

</style>
